import {BehaviorSubject, Observable} from 'rxjs';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {finalize} from 'rxjs/operators';
import {BaseNumberApi, BaseNumberModel, ListFilter, Pagination} from "@shared/base";

export class BaseNumberDatasource<M extends BaseNumberModel> implements DataSource<M> {
  private dataSubject = new BehaviorSubject<M[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public records: number;

  constructor(private baseApi: BaseNumberApi<M>) {
  }

  public get loading$(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }

  public get subject$(): Observable<M[]> {
    return this.dataSubject.asObservable();
  }

  public get data(): M[] {
    return this.dataSubject.getValue();
  }

  connect(_collectionViewer: CollectionViewer): Observable<M[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  load(filter: ListFilter, pagination: Pagination) {
    this.loadingSubject.next(true);

    this.baseApi.findByFilter(filter, pagination).pipe(
      finalize(() => this.loadingSubject.next(false))
    ).subscribe(listResult => {
      this.dataSubject.next(listResult.data);
      this.records = listResult.records;
    });
  }
}
